import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ERPConnection } from '../models/erpconnection.model';
import { SlimERPConnection } from '../models/slimerpconnection.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ErpconnectionService {

	private svcUrl = '/ERPConnections';

	constructor(private http: HttpClient, private url: UrlService) { }

	getERPConnections(): Observable<ERPConnection[]> {
		return this.http.get<ERPConnection[]>(this.url.getBaseURL() + this.svcUrl);
	}

	getERPConnection(id: number): Observable<ERPConnection> {
		return this.http.get<ERPConnection>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	createERPConnection(item: ERPConnection): Observable<ERPConnection> {
		return this.http.post<ERPConnection>(this.url.getBaseURL() + this.svcUrl, item);
	}

	getERPConnectionsForBrokerId(id: number): Observable<ERPConnection[]> {
		return this.http.get<ERPConnection[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id);
	}

	getSlimERPConnectionsForBrokerId(id: number): Observable<SlimERPConnection[]> {
		return this.http.get<SlimERPConnection[]>(this.url.getBaseURL() + this.svcUrl + '/SlimBroker/' + id);
	}

	setERPConnectionAsDefault(id: number): Observable<ERPConnection> {
		return this.http.post<ERPConnection>(this.url.getBaseURL() + this.svcUrl + '/SetERPConnectionAsDefault/' + id, {});
	}


}
